<template>

<!-- <section class="pt-0" v-if="$root.instance"> -->
<section class="pt-0">
  <notifications/>
  <form v-on:submit.prevent="createCustomer">
    <h3 class="h4">Your details:</h3>
    <div class="row">

      <div class="col">
        <div class="form-group">
          <label id="first_name">First name</label>
          <input :disabled="paymentInitiated" name="first_name"
            v-model="$root.booking.customer.first_name"
            id="first_name"
            class="form-control" required>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label>Last name</label>
          <input :disabled="paymentInitiated" name="last_name" v-model="$root.booking.customer.last_name" class="form-control" required>
        </div>
      </div>

    </div>
    <div class="row">

      <div class="col">
        <div class="form-group">
          <label>Email</label>
          <input :disabled="paymentInitiated" type="email" v-model="$root.booking.customer.email" class="form-control" required>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col">
        <div class="form-group">
          <label>Phone</label>
          <input :disabled="paymentInitiated" v-model="$root.booking.customer.phone_number" class="form-control">
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label>Mobile phone</label>
          <input :disabled="paymentInitiated" v-model="$root.booking.customer.mobile_number" class="form-control">
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col">
        <div class="form-group">
          <label>Street address</label>
          <input :disabled="paymentInitiated" v-model="$root.booking.customer.street_address" class="form-control" required>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label>Address line 2 (optional)</label>
          <input :disabled="paymentInitiated" v-model="$root.booking.customer.address_line_2" class="form-control">
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col">
        <div class="form-group">
          <label>Town</label>
          <input :disabled="paymentInitiated" v-model="$root.booking.customer.town" class="form-control" required>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label>County (optional)</label>
          <input :disabled="paymentInitiated" v-model="$root.booking.customer.county" class="form-control">
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col">
        <div class="form-group">
            <label>Postcode</label>
            <input :disabled="paymentInitiated" v-model="$root.booking.customer.postcode" class="form-control" required>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
            <label for="country">Country:</label>
            <div class="form-group">
              <select :disabled="paymentInitiated" v-model="$root.booking.customer.country_id" id="country" class="custom-select">
                <option v-for="country in $root.countries" :key="country.id" :value="country.id">{{ country.name }}</option>
              </select>
              <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4444 8.41358C14.7776 8.2281 15.1875 8.46907 15.1875 8.85048V15.1495C15.1875 15.5309 14.7776 15.7719 14.4444 15.5864L8.78505 12.4369C8.44258 12.2463 8.44258 11.7537 8.78505 11.5631L14.4444 8.41358Z" fill="#212529"></path>
              </svg>
            </div>
        </div>
      </div>

    </div>

    <div class="box px-6 pt-4">

      <h5>Do you have a voucher code?</h5>

      <Discount :booking="$root.booking" :passenger-count="$root.passengerCount"></Discount>

    </div>

    <div class="box px-6 pt-4">

      <h5>Would you prefer to pay the full amount or deposit?</h5>

      <div class="form-check">
        <label>
          <input :disabled="paymentInitiated" class="form-check-input" type="radio" v-model="paymentType" value="deposit" selected>
          Deposit ({{ $root.totalDeposit | formatCurrency }})
        </label>
      </div>

      <div class="form-check">
        <label>
          <input :disabled="paymentInitiated" class="form-check-input" type="radio" v-model="paymentType" value="full">
          Full payment ({{ $root.totalCost | formatCurrency }})
        </label>
      </div>

    </div>

    <div class="box px-6 pt-4">

      <div class="form-check">
        <label>
          <input :disabled="paymentInitiated" class="form-check-input" type="checkbox" v-model="termsConditions" required>
          I have read, understood and accept the <a href="http://mistralholidays.co.uk/booking-conditions">Booking Conditions & Essential Information.</a>
        </label>
      </div>

    </div>

    <br>

    <button type="submit" class="btn btn-primary">Next</button>

  </form>
</section>

</template>

<script>
import axios from 'axios';
import Discount from './Discount';

export default {
  name: 'Customer',
  components: {
    Discount
  },
  data () {
    return {
      paymentType : 'deposit',
	    termsConditions: false,
      paymentInitiated : false,
      paymentCompleted : false,
    }
  },
  created () {
    if(this.$root.stripeLoaded == false) {
      let stripeJS = document.createElement('script')
      stripeJS.setAttribute('src', 'https://js.stripe.com/v3/')
      document.head.appendChild(stripeJS)
      this.$root.stripeLoaded = true
    }
  },
  mounted() {
    // if(!this.$root.instance) {
    //   this.$router.push({ name: 'tour' })
    // }
  },
  computed: {
    totalAmount: function () {
      let totalAmount = this.$root.totalDeposit;
      if(this.paymentType == 'full') totalAmount = this.$root.totalCost;
      return totalAmount;
    }
  },
  methods: {
    createCustomer () {
      if (this.$root.bookingResponse) {
        this.takePayment();
      } else {
        this.$root.loading = true
        this.saveCustomer();
        axios.post(this.$root.$api + 'customers', this.$root.booking.customer)
        .then(res => res.data)
        .then(response => {
          this.$root.booking.customer = response.data
          this.$root.loading = false
          this.saveCustomer();
          this.createBooking();
        })
        .catch(error => {
          alert(error);
        })
      }
    },
    saveCustomer() {
      const parsed = JSON.stringify(this.$root.booking.customer);
      localStorage.setItem('customer', parsed);
    },
    createBooking () {
      this.$root.loading = true
      var tourBookingRequest = []
      for (let item of this.$root.booking.tour_bookings) {
        var tour_booking = {
          tour_id: item.tour_id,
          tour_instance_id: this.$root.instance.id,
          tour_room_id: item.tour_room_id,
          rooms: Math.ceil( item.guests/item.room.occupancy ),
          guests: item.guests,
          price: item.price,
          cost: item.cost,
          passengers: item.passengers
        }
        tourBookingRequest.push(tour_booking)
      }

      let affiliate_id = null
      if(this.$root.affiliate) affiliate_id = this.$root.affiliate.id

      var bookingRequest = {
        customer_id: this.$root.booking.customer.id,
        // agent_id: this.booking.agent ? this.booking.agent.id : null,
        affiliate_id: affiliate_id,
        tour_bookings: tourBookingRequest,
        departure_date: this.$root.instance.departure_date,
        discount: this.$root.booking.discount,
        passenger_count: this.$root.passengerCount,
        extras:this.$root.booking.extras
      }

      this.$root.loading = true

      axios.post(this.$root.$api + 'bookings', bookingRequest)
      .then(res => res.data)
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$root.bookingResponse = response.data;
          // if(process.env.MIX_DISABLE_STRIPE == true) {
          //   window.location = "/book#/confirmation";
          // } else {
            this.takePayment();
          // }
        } else if (response.errors) {
          this.$root.loading = false
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
      }).catch(error => {
        this.$root.loading = false;
        console.log(error.response, 'sasa')
        if(error.response.data.message) {
          this.$notify({
              type: 'error',
              title: error.response.data.message
          });
        }
      });
    },
    takePayment() {
      this.$root.loading = true;
      this.paymentInitiated = true;
      axios.get(this.$root.$api + 'bookings/payment')
      .then(res => res.data)
      .then(response => {
        console.log(response.data, 'sasas')
        if(response.data === 'stripe') {
          this.payWithStripe();
        } else if(response.data === 'ecommpay') {
          this.payWithEcommpay();
        } else {
          this.$notify({
            type: 'error',
            title: 'No payment gateway found'
          });
        }
      })
    },
    payWithStripe() {
      const stripe = Stripe(process.env.MIX_STRIPE_PUBLIC);

      axios.post(this.$root.$api + 'bookings/pay', {
        'booking_ref': this.$root.bookingResponse.booking_ref,
        'description': this.$root.instance.tour.name,
        'booking_id': this.$root.bookingResponse.id,
        // @TODO: adjust amount due to full amount if tour is x days away
        'amount': this.totalAmount * 10,
        'success_url': process.env.MIX_APP_URL + '/book#/confirmation?payment_id={CHECKOUT_SESSION_ID}',
        'cancel_url': process.env.MIX_APP_URL + '/book#/failure'
      })
      .then(res => res.data)
      .then(response => {
        this.$root.loading = false;
        stripe.redirectToCheckout({
          sessionId: response.data.id
        }).then((result) => {
          this.$root.loading = false
          this.$router.push({ name: 'failure' })
        });
      })
      .catch(error => {
        // console.log(error);
      })
    },
    payWithEcommpay() {
      axios.post(this.$root.$api + 'bookings/ecommpay/pay', {
        'booking_ref': this.$root.bookingResponse.booking_ref,
        'description': this.$root.bookingResponse.booking_ref + ' - ' + this.$root.instance.tour.name + ' - ' + this.$options.filters.formatDate(this.$root.instance.departure_date),
        'booking_id': this.$root.bookingResponse.id,
        'customer_id':  this.$root.booking.customer.id,
        'customer_email' : this.$root.bookingResponse.customer_email,
        // @TODO: adjust amount due to full amount if tour is x days away
        'amount': this.totalAmount,
        'success_url': process.env.MIX_APP_URL + '/book#/confirmation',
        'cancel_url': process.env.MIX_APP_URL + '/book#/failure'
      })
      .then(res => res.data)
      .then(response => {
        this.$root.loading = false;
        // window.location.href = response.redirect;
        const self  = this;
        EPayWidget.run(
          {
            "project_id": response.data.project_id,
            "interface_type": response.data.interface_type,
            "payment_id": response.data.payment_id,
            "payment_amount": response.data.payment_amount,
            "payment_currency": response.data.payment_currency,
            "payment_description": response.data.payment_description,
            "customer_id": response.data.customer_id,
            'customer_email' : response.data.customer_email,
            "payment_extra_param": response.data.payment_extra_param,
            "merchant_return_url": response.data.merchant_return_url,
            "signature": response.data.signature,
            onPaymentSuccess: function () {
              console.log('onPaymentSuccess')
              self.paymentCompleted = true;
              setTimeout(() => {
                self.$router.push({ name: 'confirmation' })
                this.closePopup() // close payment modal
              }, 15000);
            },
            onExit: function () {
              console.log('onExit')
              if(self.paymentCompleted) {
                self.$router.push({ name: 'confirmation' })
              }
            },
          }
        );
      })
      .catch(error => {
        console.log(error);
      })
    }
  }
}
</script>
